// Validación del periodo de inscripciones de pregrado, compartida por la pantalla de inicio
// (InscripcionInicio) y el ingreso directo al formulario v2 (InscripcionAgregar).
// Regla: el periodo está abierto si faltan 0 días o más para la fecha de cierre (valora de Per_Ins).
import moment from "moment";
import { obtenerValoresFiltros } from "../../global/js/funciones";

export async function periodoInscripcionAbierto() {
  const periodo = await obtenerValoresFiltros([{ llave: "codigo", valor: "Per_Ins" }]);
  const fecha_hoy = moment();
  const fecha_vence = moment(periodo[0].valora);
  const dias = fecha_vence.diff(fecha_hoy, "days");
  return dias >= 0;
}
